<template>
  <div class="relative z-10">
    <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center px-2 text-gray-700">
      <span class="ico__filter"></span>
    </div>
    <div 
      class="block  appearance-none w-full bg-white-200 text-gray-700 py-3 pl-12 pr-8 cursor-pointer rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state"
      dava-vs-button="button-show-list-filter"
      @click="showList=!showList"
    >
      {{ selectedItem }}
    </div>
    <div 
      v-show="showList"
      class="origin-top-right absolute right-0 mt-2 w-56 max-h-64 rounded shadow-lg bg-white" 
    >
      <div 
        class="block cursor-pointer px-4 py-2 text-sm leading-5 text-gray-700 rounded hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
        v-for="(item, index) in items" 
        :key="item"
        :data-vs-button="`modal-button-item-filter-${index}`"
        @click="$emit('input', item); selectedItem=item; showList=false"
      >
        {{ item }}
      </div>
    </div>
    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
      <span class="ico__arrow"></span>
    </div>
  </div>
</template>

<script>
export default {

  props:{
    value: null,
    items: Array
  },
  data(){
    return {
      selectedItem: null,
      showList: false
    }
  },
  methods: {
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.showList = false;
      }
    }
  },
  mounted () {
    this.selectedItem = this.value;
    document.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.removeEventListener('click',this.close)
  },
  watch: {
    value: function (newValue) {
      this.selectedItem = newValue;
    }
  }

}
</script>

<style scoped lang="scss">

  .max-h-64 {
    max-height: 16rem;
    overflow-y: auto;
  }

  .ico__filter {
    width: 34px;
    height: 25px;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAzMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjQ2MTEgMkMxMC4xNjg5IDIgOS4wNzA0OCAyLjg3MjI1IDguNzE1MTIgNC4wNjc1NUg1Ljc3NTMzQzUuMzIzMDUgNC4wNjc1NSA1IDQuNDIyOTEgNSA0Ljg3NTE4QzUgNS4zMjc0NiA1LjM1NTM2IDUuNjgyODIgNS44MDc2NCA1LjY4MjgySDguNzQ3NDNDOS4wNzA0OCA2Ljg3ODEyIDEwLjIwMTIgNy43NTAzNyAxMS40OTM0IDcuNzUwMzdDMTIuODE3OSA3Ljc1MDM3IDEzLjkxNjMgNi44NzgxMiAxNC4yNzE3IDUuNjgyODJIMjYuMTkyNEMyNi42NDQ2IDUuNjgyODIgMjcgNS4zMjc0NiAyNyA0Ljg3NTE4QzI3IDQuNDIyOTEgMjYuNjQ0NiA0LjA2NzU1IDI2LjE5MjQgNC4wNjc1NUgxNC4yNzE3QzEzLjg4NCAyLjg3MjI1IDEyLjc4NTYgMiAxMS40NjExIDJaTTExLjQ5MzQgMy42MTUyN0MxMi4xNzE4IDMuNjE1MjcgMTIuNzUzMyA0LjE2NDQ2IDEyLjc1MzMgNC44NzUxOEMxMi43NTMzIDUuNTg1OSAxMi4xNzE4IDYuMTM1MSAxMS40OTM0IDYuMTM1MUMxMC44MTUgNi4xMzUxIDEwLjIzMzUgNS41ODU5IDEwLjIzMzUgNC44NzUxOEMxMC4yMzM1IDQuMTY0NDYgMTAuODE1IDMuNjE1MjcgMTEuNDkzNCAzLjYxNTI3WiIgZmlsbD0iIzRGNDFBMyIvPgo8cGF0aCBkPSJNMjEuMTg1IDguNDYwOTRDMTkuODkyOCA4LjQ2MDk0IDE4Ljc5NDQgOS4zMzMxOCAxOC40MzkxIDEwLjUyODVINS44MDc2NEM1LjMyMzA1IDEwLjUyODUgNSAxMC44ODM4IDUgMTEuMzM2MUM1IDExLjc4ODQgNS4zNTUzNiAxMi4xNDM4IDUuODA3NjQgMTIuMTQzOEgxOC40MzkxQzE4Ljc2MjEgMTMuMzM5MSAxOS44OTI4IDE0LjIxMTMgMjEuMTg1IDE0LjIxMTNDMjIuNTA5NSAxNC4yMTEzIDIzLjYwNzkgMTMuMzM5MSAyMy45NjMzIDEyLjE0MzhIMjYuMTkyNEMyNi42NDQ2IDEyLjE0MzggMjcgMTEuNzg4NCAyNyAxMS4zMzYxQzI3IDEwLjg4MzggMjYuNjQ0NiAxMC41Mjg1IDI2LjE5MjQgMTAuNTI4NUgyMy45NjMzQzIzLjYwNzkgOS4zMzMxOCAyMi41MDk1IDguNDYwOTQgMjEuMTg1IDguNDYwOTRaTTIxLjIxNzMgMTAuMDc2MkMyMS44OTU3IDEwLjA3NjIgMjIuNDc3MiAxMC42MjU0IDIyLjQ3NzIgMTEuMzM2MUMyMi40NzcyIDEyLjA0NjggMjEuODk1NyAxMi41OTYgMjEuMjE3MyAxMi41OTZDMjAuNTM4OSAxMi41OTYgMTkuOTU3NCAxMi4wNDY4IDE5Ljk1NzQgMTEuMzM2MUMxOS45NTc0IDEwLjYyNTQgMjAuNTA2NiAxMC4wNzYyIDIxLjIxNzMgMTAuMDc2MloiIGZpbGw9IiM0RjQxQTMiLz4KPHBhdGggZD0iTTE1LjMzNzcgMTUuNTY4NEMxNC4wNDU1IDE1LjU2ODQgMTIuOTQ3MSAxNi40NDA2IDEyLjU5MTggMTcuNjM1OUg1LjgwNzY0QzUuMzIzMDUgMTcuNjM1OSA1IDE3Ljk5MTMgNSAxOC40NDM1QzUgMTguODk1OCA1LjM1NTM2IDE5LjI1MTIgNS44MDc2NCAxOS4yNTEySDEyLjYyNDFDMTIuOTQ3MSAyMC40NDY1IDE0LjA3NzggMjEuMzE4NyAxNS4zNyAyMS4zMTg3QzE2LjY5NDYgMjEuMzE4NyAxNy43OTMgMjAuNDQ2NSAxOC4xNDgzIDE5LjI1MTJIMjYuMTkyNEMyNi42NDQ2IDE5LjI1MTIgMjcgMTguODk1OCAyNyAxOC40NDM1QzI3IDE3Ljk5MTMgMjYuNjQ0NiAxNy42MzU5IDI2LjE5MjQgMTcuNjM1OUgxOC4xMTZDMTcuNzYwNiAxNi40NDA2IDE2LjY2MjMgMTUuNTY4NCAxNS4zMzc3IDE1LjU2ODRaTTE1LjM3IDE3LjE4MzZDMTYuMDQ4NSAxNy4xODM2IDE2LjYzIDE3LjczMjggMTYuNjMgMTguNDQzNUMxNi42MyAxOS4xNTQzIDE2LjA0ODUgMTkuNzAzNSAxNS4zNyAxOS43MDM1QzE0LjY5MTYgMTkuNzAzNSAxNC4xMTAxIDE5LjE1NDMgMTQuMTEwMSAxOC40NDM1QzE0LjE0MjQgMTcuNzMyOCAxNC42OTE2IDE3LjE4MzYgMTUuMzcgMTcuMTgzNloiIGZpbGw9IiM0RjQxQTMiLz4KPC9zdmc+Cg==);
  }

  .ico__arrow {
    width: 10px;
    height: 5px;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEwIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuNTQiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwTDUgNUwxMCAwSDBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K);
  }

	.max-h-64::-webkit-scrollbar {
		width: 8px;
	}

	.max-h-64::-webkit-scrollbar-track {
		box-shadow: inset 0 0 0 grey; 
	}

	.max-h-64::-webkit-scrollbar-thumb {
		background: #E4527F; 
	}

	.max-h-64::-webkit-scrollbar-thumb:hover {
		background: #EC96B0; 
	}
  


</style>